import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 6.75C7.5 4.67893 9.17894 3 11.25 3C13.3211 3 15 4.67893 15 6.75C15 8.82106 13.3211 10.5 11.25 10.5C11.0856 10.5 10.9235 10.4894 10.7642 10.4688L10.5227 10.7102C10.4173 10.8157 10.2742 10.875 10.125 10.875H9.375V11.625C9.375 11.7742 9.31574 11.9173 9.21025 12.0227L8.27275 12.9602C8.16726 13.0657 8.02418 13.125 7.875 13.125H7.125V13.875C7.125 14.0242 7.06574 14.1673 6.96025 14.2727L6.39775 14.8352C6.29226 14.9407 6.14918 15 6 15H3.5625C3.25184 15 3 14.7482 3 14.4375V12C3 11.8508 3.05926 11.7077 3.16475 11.6023L7.53124 7.23578C7.51061 7.07655 7.5 6.91439 7.5 6.75ZM11.25 4.125C9.80026 4.125 8.625 5.30025 8.625 6.75C8.625 6.94233 8.64558 7.12918 8.68447 7.30868C8.72497 7.4956 8.66771 7.6903 8.53247 7.82554L4.125 12.233V13.875H5.76701L6 13.642V12.5625C6 12.2518 6.25184 12 6.5625 12H7.64201L8.25 11.392V10.3125C8.25 10.0018 8.50184 9.75 8.8125 9.75H9.89201L10.1745 9.46753C10.3097 9.33228 10.5044 9.27503 10.6913 9.31553C10.8708 9.35442 11.0577 9.375 11.25 9.375C12.6997 9.375 13.875 8.19974 13.875 6.75C13.875 5.30025 12.6997 4.125 11.25 4.125Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.25 6C11.25 5.58577 11.5858 5.25 12 5.25C12.4142 5.25 12.75 5.58577 12.75 6C12.75 6.41423 12.4142 6.75 12 6.75C11.5858 6.75 11.25 6.41423 11.25 6Z"
      fill="currentColor"
    />
  </SvgIcon>
));
